import { render, staticRenderFns } from "./batchLeavePop.vue?vue&type=template&id=50f87064&scoped=true&"
import script from "./batchLeavePop.vue?vue&type=script&lang=js&"
export * from "./batchLeavePop.vue?vue&type=script&lang=js&"
import style0 from "./batchLeavePop.vue?vue&type=style&index=0&id=50f87064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f87064",
  null
  
)

export default component.exports